CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Tag = require 'models/tag'

module.exports = class TagList extends CollectionWithHelpers
  model: Tag

  comparator: (tag1, tag2) -> tag1.get('name').localeCompare(tag2.get('name'))



// WEBPACK FOOTER //
// ./app/scripts/models/collections/tag-list.coffee